import React from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';

import { openDrawer } from '../../../slices/accounts/video/management';
import { DrawerLauncher } from '../DrawerLauncher';

const ManageMinutes: React.FC = () => {
  const dispatch = useDispatch();

  const handleOpenDrawer = () => {
    dispatch(openDrawer());
  };

  return (<>
    <Button type='primary' onClick={handleOpenDrawer}>
      Manage minutes
    </Button>
    <DrawerLauncher />
  </>);
};

export { ManageMinutes };
